import React from "react";
import s from "./Button.module.scss";

const cx = (...a) => a.filter(Boolean).join(" ");

function Button({
  as: Tag = "button",
  children,
  variant = "primary",   // primary | secondary | ghost
  size = "md",           // sm | md | lg
  onClick,
  className,
  ...rest
}) {
  return (
    <Tag
      className={cx(s.btn, s[`v_${variant}`], s[`s_${size}`], className)}
      onClick={onClick}
      {...rest}
    >
      {children}
    </Tag>
  );
}

export default Button;
